import { render, staticRenderFns } from "./createEvent.vue?vue&type=template&id=391f081e&scoped=true"
import script from "./createEvent.vue?vue&type=script&lang=js"
export * from "./createEvent.vue?vue&type=script&lang=js"
import style0 from "./createEvent.vue?vue&type=style&index=0&id=391f081e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f081e",
  null
  
)

export default component.exports